import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { RoutePaths } from '../classes/RoutePaths/RoutePaths';
import { useEntityManager } from '../hooks/entity/useEntityManager';
import { useCurrentUser } from '../hooks/useCurrentUser';
import { AuthenticatedPermission, NavigationConfigurationWithKey } from './navigationConfigurations';
export type AppRouteElementWrapperProps = {
  config: NavigationConfigurationWithKey;
};
export const AppRouteElementWrapper: FunctionComponent<AppRouteElementWrapperProps> = React.memo(props => {
  const $ = _c(7);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    config
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  let t2;
  if ($[2] !== config.titleTk || $[3] !== t) {
    t1 = () => {
      document.title = String(t(config.titleTk));
    };
    t2 = [t, config.titleTk];
    $[2] = config.titleTk;
    $[3] = t;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  const params = useParams();
  const {
    entityManager
  } = useEntityManager();
  const {
    getRequiredCurrentUserPermissions
  } = useCurrentUser();
  let hasPermission = true;
  if (config.permissions.authenticated === AuthenticatedPermission.OnlyAuthenticated && config.permissions.checkUserPermissions) {
    hasPermission = config.permissions.checkUserPermissions({
      userPermissions: getRequiredCurrentUserPermissions(),
      params,
      entityManager
    });
  }
  if (!hasPermission) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Navigate to={RoutePaths.home()} />;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  return config.routeProps.element;
});